/**
 * Delivery method codes enum
 */
export enum DeliveryMethodCode {
  SELF = "self",
  ADDRESS = "address",
  NOVAPOSHTA_WAREHOUSE = "novaposhta_warehouse",
  NOVAPOSHTA_COURIER = "novaposhta_courier",
  NOVAPOSHTA_PARCEL_LOCKERS = "novaposhta_parcel_lockers",
  UKRPOSHTA = "ukrposhta",
}

// /**
//  * Mapping of delivery method codes to their corresponding form field label IDs
//  */
// export const DELIVERY_LABEL_MAP: Record<string, string> = {
//   // [DeliveryMethodCode.SELF]: "orderSelfWarehouse",
//   [DeliveryMethodCode.ADDRESS]: "orderCourierStreet",
//   [DeliveryMethodCode.NOVAPOSHTA_WAREHOUSE]: "orderNovaPoshtaWarehouse",
//   [DeliveryMethodCode.NOVAPOSHTA_COURIER]: "orderNovaPoshtaStreet",
//   [DeliveryMethodCode.NOVAPOSHTA_PARCEL_LOCKERS]: "orderNovaPoshtaParcelLocker",
// //   [DeliveryMethodCode.UKRPOSHTA]: "orderUkrposhta",
// }

// /**
//  * Mapping of delivery method codes to their corresponding form field names
//  */
// export const DELIVERY_FIELDS_MAP: Record<string, string> = {
//   [DeliveryMethodCode.ADDRESS]: "novaposhta_street",
//   [DeliveryMethodCode.NOVAPOSHTA_WAREHOUSE]: "novaposhta_warehouse",
//   [DeliveryMethodCode.NOVAPOSHTA_COURIER]: "novaposhta_street",
//   [DeliveryMethodCode.NOVAPOSHTA_PARCEL_LOCKERS]: "novaposhta_parcel_lockers",
// //   [DeliveryMethodCode.UKRPOSHTA]: "ukrposhta",
// }

// /**
//  * Get the API URL for Nova Poshta based on delivery code and city code
//  * @param code - The delivery method code
//  * @param cityCode - The Nova Poshta city code
//  * @returns The API URL for fetching Nova Poshta locations
//  */
// export const getNovaPoshtaApiUrl = (code: string, cityCode: string): string => {
//   const locale = typeof window !== "undefined" ? (window as any).locale : "uk"
//   switch (code) {
//     case DeliveryMethodCode.NOVAPOSHTA_WAREHOUSE:
//       return `/api/novaposhta/warehouses/${cityCode}?locale=${locale}&q=`
//     case DeliveryMethodCode.NOVAPOSHTA_PARCEL_LOCKERS:
//       return `/api/novaposhta/parsel_locker/${cityCode}?locale=${locale}&q=`
//     default:
//       return `/api/novaposhta/streets/${cityCode}?locale=${locale}&q=`
//   }
// }
